import { loginConstants } from "../../actionTypes";

// let user: any = "";
// const initialState = user ? { loggedIn: true, user } : {};
const initialState = {
  loggedInUserData: {},
  loggedInUserPermission: {},
};

export function loginReducer(state: any = initialState, action: any) {
  switch (action.type) {
    case loginConstants.GETALL_REQUEST:
      return {
        loading: true,
      };
    case loginConstants.GETALL_SUCCESS:
      return {
        items: action.users,
      };
    case loginConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
      };
    case loginConstants.LOGGEDIN_USERDATA:
      return {
        ...state,
        loggedIn: true,
        loggedInUserData: action.payload,
      };
    case loginConstants.LOGGEDIN_USERPERMISSION:
      return {
        ...state,
        loggedIn: true,
        loggedInUserPermission: action.payload,
      };
    case loginConstants.LOGIN_FAILURE:
      return {};
    case loginConstants.GETALL_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
